<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center> {{$route.name}}</b-navbar-brand>

          <b-button v-if="
              $sessionsStorage.get('designation') == 'Admin' &&
              $sessionsStorage.get('nameUser') == 'Bhavneesh'
            " :disabled="ExcelBtnName != 'Export As Excel' ? true : false" class="ml-3"
            @click="getReports('Vendor_List', 'Export As Excel')" size="sm" variant="outline-info">{{ ExcelBtnName }}
            <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>

            <!-- Salil - modal for multiple gst entries-->
            <b-card class="gutr" v-if="addMultipleCard">
              <b-row>
                <b-col md="12">
                  <h5>
                    {{ VendorMaster.vendor_id ? "Update " : "Add " }}
                    {{ VendorMaster.vendor_LglNm }} Multiple GST PO Vendor Details
                  </h5>
                </b-col>

                <b-col md="3">
                  <label>
                    PO Vendor Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_LglNm" name="vendor_LglNm" v-model="VendorMaster.vendor_LglNm"
                    placeholder="Enter Vendor Name"></b-form-input>
                  <span class="error" v-if="!VendorMaster.vendor_LglNm">
                    {{ errorList.vendor_LglNm }}
                  </span>
                </b-col>

                <b-col md="3" class="mt-4" v-if="VendorMaster.vendor_type == 2">
                  <label>Status: </label><span class="error">*</span>
                  <md-switch :id="'approval' + VendorMaster.vendor_is_active" name="approval" class="md-primary"
                    :value="VendorMaster.vendor_is_active == true ? true : false" @change="activateVendorMaster()">
                    <h6>
                      <b-badge :variant="
                          VendorMaster.vendor_is_active == 1 ? 'success' : 'danger'
                        ">{{
                        VendorMaster.vendor_is_active == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
              </b-row>

              <b-row class="mt-2 ml-1">
                <b-col>
                  <label></label>
                  <b-form-checkbox size="lg" v-model="is_without_gst"> Check if Vendor do not have GST
                    Number</b-form-checkbox>
                </b-col>
              </b-row>

              <b-row class="mt-4 ml-2">
                <b-button id="show-btn" size="sm" variant="outline-primary" @click="addGstArray">
                  Add Multiple GST <i class="fa fa-plus" aria-hidden="true"></i>
                </b-button>
              </b-row>

              <b-row class="mt-2 ml-2">
                <b-card class="mt-2 " style="width: 100%;" v-for="(items, idx) in newGstArray" :key="idx">
                  <div class="d-flex align-items-center" v-if="idx != 0">
                    <b-button class="ml-auto mb-2" id="show-btn" size="sm" variant="danger" @click="removeGstArry(idx)">
                      Remove Expenses <i class="fa fa-plus" aria-hidden="true"></i>
                    </b-button>
                  </div>

                  <b-row align-v="start">
                    <b-col md="3">
                      <label>PO Vendor Add</label><span class="error">*</span>
                      <b-textarea size="sm" id="vendor_Addr1" name="vendor_Addr1" v-model="items.vendor_Addr1"
                        placeholder="Please Enter Address"></b-textarea>
                      <span class="error" v-if="!items.vendor_Addr1">{{ errorList.vendor_Addr1 }}</span>
                    </b-col>

                    <b-col md="3" v-if="!is_without_gst">
                      <label>GST No</label><span class="error">*</span>
                      <b-form-input size="sm" id="vendor_Gstin" name="vendor_Gstin" v-model="items.vendor_Gstin"
                        placeholder="Please Enter GST NO"></b-form-input>
                      <span class="error" v-if="!items.vendor_Gstin">{{ errorList.vendor_Gstin }}</span>
                    </b-col>

                    <!-- <b-col md="3">
                      <label>State</label><span class="error">*</span>
                      <b-form-input
                        size="sm"
                        id="vendor_Loc"
                        name="vendor_Loc"
                        v-model="items.vendor_Loc"
                        placeholder="Please Enter State"
                      ></b-form-input>
                      <span class="error" v-if="!items.vendor_Loc">{{ errorList.vendor_Loc }}</span>
                    </b-col>

                    <b-col md="3">
                      <label>State Code</label><span class="error">*</span>
                      <b-form-input
                        size="sm"
                        id="vendor_Stcd"
                        name="vendor_Stcd"
                        v-model="items.vendor_Stcd"
                        placeholder="State Code"
                      ></b-form-input>
                      <span class="error" v-if="!items.vendor_Stcd">{{ errorList.vendor_Stcd }}</span>
                    </b-col> -->

                  </b-row>
                </b-card>
              </b-row>

              <b-col md="12">
                <center>
                  <b-button style="margin-bottom: 0.3rem" variant="success" @click="addVendorMaster" class="mt-2"
                    id="addButtonLoader">
                    {{ VendorMaster.vendor_id ? "Update" : "Save" }}
                  </b-button>
                </center>

                <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
              </b-col>
            </b-card>
            <!-- Salil - modal for multiple gst entries end-->



            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>
                    {{ VendorMaster.vendor_id ? "Update " : "Add " }}
                    {{ VendorMaster.vendor_LglNm }} Vendor Details
                  </h5>
                </b-col>

                <!-- {{ MasterVendorList.vendor_type }} -->
                <b-col md="3">
                  <label>
                    Vendor Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_LglNm" name="vendor_LglNm" v-model="VendorMaster.vendor_LglNm"
                    :disabled="
                      VendorMaster.vendor_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorMaster.vendor_id
                        ? true
                        : false
                    " placeholder="State Name"></b-form-input>
                  <span class="error" v-if="!VendorMaster.vendor_LglNm">
                    {{ errorList.vendor_LglNm }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Vendor Add
                    <span class="error">*</span>
                  </label>
                  <b-textarea size="sm" id="vendor_Addr1" name="vendor_Addr1" v-model="VendorMaster.vendor_Addr1"
                    :disabled="
                      VendorMaster.vendor_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorMaster.vendor_id
                        ? true
                        : false
                    " placeholder="Please Enter Address"></b-textarea>
                  <span class="error" v-if="!VendorMaster.vendor_Addr1">
                    {{ errorList.vendor_Addr1 }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    State
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_Loc" name="vendor_Loc" v-model="VendorMaster.vendor_Loc" :disabled="
                      VendorMaster.vendor_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorMaster.vendor_id
                        ? true
                        : false
                    " placeholder="Please Enter State"></b-form-input>
                  <span class="error" v-if="!VendorMaster.vendor_Loc">
                    {{ errorList.vendor_Loc }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    State Code
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_Stcd" name="vendor_Stcd" v-model="VendorMaster.vendor_Stcd"
                    :disabled="
                      VendorMaster.vendor_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorMaster.vendor_id
                        ? true
                        : false
                    " placeholder="State Code"></b-form-input>
                  <span class="error" v-if="!VendorMaster.vendor_Stcd">
                    {{ errorList.vendor_Stcd }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    GST No
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_Gstin" name="vendor_Gstin" v-model="VendorMaster.vendor_Gstin"
                    :disabled="
                      VendorMaster.vendor_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorMaster.vendor_id
                        ? true
                        : false
                    " placeholder="Please Enter GST NO"></b-form-input>
                  <span class="error" v-if="!VendorMaster.vendor_Gstin">
                    {{ errorList.vendor_Gstin }}
                  </span>
                </b-col>

                <!-- {{ VendorMaster.vendor_type }} -->
                <b-col md="3" v-if="(VendorMaster.vendor_type == 2 && 
                  VendorMaster.vendor_Gstin!=undefined && 
                  VendorMaster.vendor_Gstin!=null && 
                  VendorMaster.vendor_Gstin!='') || VendorMaster.vendor_type == 3">
                  <label>
                    Status :
                    <span class="error">*</span>
                  </label>
                  <md-switch :id="'approval' + VendorMaster.vendor_is_active" name="approval" class="md-primary"
                    :value="VendorMaster.vendor_is_active == true ? true : false" @change="activateVendorMaster()">
                    <h6>
                      <b-badge :variant="
                          VendorMaster.vendor_is_active == 1 ? 'success' : 'danger'
                        ">{{
                        VendorMaster.vendor_is_active == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addVendorMaster" class="mt-2"
                      id="addButtonLoader">
                      {{ VendorMaster.vendor_id ? "Update" : "Save" }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->



            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="8" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Vendor Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <model-list-select class="ml-1" :list="vendorTypeArr" v-model="vendorTypeFilter"
                    option-value="vendorType" option-text="vendorTypeText" placeholder="Select vendor type filter"
                    @input="getVendorMaster('Normal')"></model-list-select>
                </b-col>

                <b-col md="1">
                  <b-button v-if="$route.path!='/povendorMaster'" variant="outline-primary" @click="addEditCardFunc()"
                    size="sm">Add</b-button>
                </b-col>

                <b-col md="1">
                  <h5 class="text-muted mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>

              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="MasterVendorList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered" responsive primary-key="vendor_id"
                  class="position-relative">
                  <template slot="vendor_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="vendor_LglNm" slot-scope="row1">
                    <b-button @click="viewAddress(row1.item)" variant="outline-info" size="xs"
                      style="font-size: 0.675rem" class="mt-1">{{ row1.item.vendor_LglNm }}</b-button>
                    <!-- <span>{{ row1.item.vendor_LglNm }}</span> -->
                  </template>
                  <template slot="vendor_Addr1" slot-scope="row2">
                    <span>{{ row2.item.vendor_Addr1 }}</span>
                  </template>
                  <template slot="vendor_Loc" slot-scope="row3">
                    <span>{{ row3.item.vendor_Loc }}</span>
                  </template>
                  <template slot="vendor_Stcd" slot-scope="row4">
                    <span>{{ row4.item.vendor_Stcd }}</span>
                  </template>
                  <template slot="vendor_Gstin" slot-scope="row5">
                    <span>{{ row5.item.vendor_Gstin }}</span>
                  </template>
                  <template slot="vendor_is_active" slot-scope="row6">
                    <div :id="'row' + row6.item.vendor_id">
                      <md-switch
                        v-if="(row6.item.vendor_type == 2 && row6.item.vendor_Gstin) || (row6.item.vendor_type == 3)"
                        :id="'approval' + row6.item.vendor_id" name="approval" class="md-primary"
                        :value="row6.item.vendor_is_active == 1 ? true : false" @change="activateVendor(row6.item)">
                      </md-switch>

                      <b-badge :variant="row6.item.vendor_is_active == 1 ? 'success' : 'danger'">
                        {{ row6.item.vendor_is_active == 1 ? "Active" : "In-Active"}}
                      </b-badge>
                    </div>
                  </template>
                  <template slot="creationTime" slot-scope="row7"><span>{{ row7.item.creationTime }}</span></template>

                  <template slot="action" slot-scope="row8">
                    <b-button variant="outline-primary" @click="editVendorLocation(row8.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vendorMaster");
      if (globalPermissionStatus("Vendor Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Vendor Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getVendorMaster("Normal");
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      newGstArray: [],
      addMultipleCard: false,
      addEditCard: false,
      isLoading: false,

      vendorTypeFilter: "",

      vendorTypeArr: [
        {
          vendorType: 4,
          vendorTypeText: "All Vendors"
        },
        {
          vendorType: 1,
          vendorTypeText: "Tally Vendors"
        },
        {
          vendorType: 2,
          vendorTypeText: "Response Vendors"
        },
        {
          vendorType: 3,
          vendorTypeText: "Normal Vendors"
        }
      ],

      fields: [
        {
          key: "vendor_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_LglNm",
          label: "Vendor Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_Addr1",
          label: "Address",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_Loc",
          label: "State",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_Stcd",
          label: "State Code",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "vendor_Gstin",
          label: "GST",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_is_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "creationTime",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      is_without_gst: true,
      ExcelBtnName: "Export As Excel",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get("designation"),
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      Filter:{ statusFilter: "3"},
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      VendorMaster: {
        vendor_id: "",
        vendor_LglNm: "",
        vendor_Addr1: "",
        vendor_Loc: "",
        vendor_Stcd: "",
        vendor_Gstin: "",
        vendor_is_active: true,
        TypeofAdd: "Vendor Master Add",
      },
      VendorMasterError: [
        "Please Enter Vendor Name",
        "Please Enter Vendor Address",
        "Please Enter State Name",
        "Please Select State Code",
        "Please Enter GST No",
      ],
      errorList: {
        vendor_LglNm: "",
        vendor_Addr1: "",
        vendor_Loc: "",
        vendor_Stcd: "",
        vendor_Gstin: "",
      },

      MasterVendorList: [],
      validate: true,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    addGstArray() {
      let obj = {
        invId: "",
        exp_id: "",
        
        vendor_Addr1: "",
        vendor_Stcd: "",
        vendor_Loc: "",
        vendor_Gstin: "",
      };
      this.newGstArray.push(obj);

      console.log(this.newGstArray.length);
    },

    removeGstArry(index) {
      this.newGstArray.splice(index, 1);
    },
    
    activateVendor(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.vendor_is_active = this.itemObj.vendor_is_active == 1 ? 0 : 1;
      let paylod = {
        tableName: "master_tbe_vendor",
        tableId: "vendor_id",
        tableIsActive: "vendor_is_active",
        value1: this.itemObj.vendor_is_active,
        tableVal: item.vendor_id,
        isMailSend:'No',
         manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Vendor ACtive Error: ", error);
        });
    },
    clearErrVal() {
      this.VendorMaster = {
        vendor_id: "",
        vendor_LglNm: "",
        vendor_Addr1: "",
        vendor_Loc: "",
        vendor_Stcd: "",
        vendor_Gstin: "",
        vendor_is_active: true,
        TypeofAdd: "Vendor Master Add",
      };
      this.errorList = {
        vendor_LglNm: "",
        vendor_Addr1: "",
        vendor_Loc: "",
        vendor_Stcd: "",
        vendor_Gstin: "",
      };
    },

    editVendorLocation(item) {

      this.clearErrVal();
      if(this.$route.path=='/povendorMaster'){
        this.addEditCard = false;
        this.addMultipleCard = true;
      } else {
        this.addEditCard = true;
      }
      item.TypeofAdd = "Vendor Master Add";
      this.VendorMaster = item;
      this.newGstArray = item.new_gst_array?JSON.parse(item.new_gst_array):[];
      this.is_without_gst = item.is_without_gst==1?true:false;
      this.setFocus();
    },

    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    activateVendorMaster() {
      if ( this.VendorMaster.vendor_is_active == 1 || this.VendorMaster.vendor_is_active == true) {
        this.VendorMaster.vendor_is_active = false;
      } else if ( this.VendorMaster.vendor_is_active == 0 || this.VendorMaster.vendor_is_active == false) {
        this.VendorMaster.vendor_is_active = true;
      }
    },
    goBack() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getVendorMaster("Normal");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getVendorMaster("Normal");
      this.Filter={ statusFilter: "3"}
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    validateVendorMaster() {
      let validate_new = true;

      let i = 0;
      let errCount = 0;
      let MainARR = this.newGstArray;

      for (let j = 0; j < MainARR.length; j++) {

        if (MainARR[j].vendor_Addr1 == "") {
          this.errorList.vendor_Addr1 = "Vendor Address required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.errorList.vendor_Addr1 = "";
          validate_new = true;
        }

        if (MainARR[j].vendor_Gstin == "" && !this.is_without_gst) {
          this.errorList.vendor_Gstin = "Vendor GST required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.errorList.vendor_Gstin = "";
          validate_new = true;
        }  

        // if (MainARR[j].vendor_Loc == "") {
        //   this.errorList.vendor_Loc = "Vendor State required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.errorList.vendor_Loc = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].vendor_Stcd == "") {
        //   this.errorList.vendor_Stcd = "Vendor State Code required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.errorList.vendor_Stcd = "";
        //   validate_new = true;
        // }  

      }
      
      if (errCount > 0) {
        this.validate = false;
      } else {
        this.validate = true;
      }

      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addVendorMaster() {
      this.VendorMaster.TypeofAdd = "Vendor Master Add";

      if (this.validate == false) return false; 
      this.isLoading = true;

      let payload = {
        itemCode: "add_Vendor_Details",
        VendorMaster: this.VendorMaster,
        newGstArray: this.newGstArray,
        is_without_gst: this.is_without_gst,
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllExpenseList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.vendor_id != "" && data.vendor_id != undefined) {

              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }

              this.addEditCardFunc();
              this.getVendorMaster("Normal");
              this.addEditCard = false;
              
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getVendorMaster("Excell");
    },

    getVendorMaster(type) {
      
      this.isLoading = true;
      let payload = {
        itemCode: "All_Vendor_List",
        Filter: { statusFilter: "3"},
        type: type ? type : "Normal",
        statusFilter: this.$route.path=='/povendorMaster'?'2':'1',
        vendorTypeFilter: this.vendorTypeFilter,
      };

      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              this.ExcelBtnName = "Export As Excel";
              if (data.MasterVendorList.length > 0) {
                this.MasterVendorList = data.MasterVendorList;
                this.totalRows = data.MasterVendorList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.MasterVendorList.length > 0) {
                this.MasterVendorList = data.MasterVendorList;
                this.totalRows = data.MasterVendorList.length;
                console.log(" getAllExpenseList response=>", data);
              }
            }

          } else {
            this.MasterVendorList = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    },

    viewAddress(item) {
      this.$sessionsStorage.set("tallyVendorId", "");
      this.$sessionsStorage.set("tallyVendorId", item.vendor_id);
      this.$router.push({
        path: "/vendorgstMaster",
      });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// vendorMaster.vue?f705ef04